const Height = ({min, max}) => (
    <span className="height">{`${min} - ${max} m`}</span>
);

export default Height;
